var generateStyle = function generateStyle(componentTheme) {
  return {
    root: {
      itemWrapper: {
        borderBottom: "".concat(componentTheme.itemWrapperBorderWidth, " solid ").concat(componentTheme.itemWrapperBorderColor),
        outline: 'none',
        '&:first-of-type': {
          borderTop: "".concat(componentTheme.itemWrapperBorderWidth, " solid ").concat(componentTheme.itemWrapperBorderColor)
        }
      }
    }
  };
};
export default generateStyle;